import snsAxiosClient from '../common/http/http-sns';
import { get } from 'lodash';

function skipItem(environmentVariables, user, skipItemInfo) {
  const payload = { ...skipItemInfo };
  const options = {
    headers: {
      ...get(environmentVariables, 'API_HEADERS_PATCH_V1'),
      Authorization: `Bearer ${get(user, 'authToken')}`,
    },
  };
  return snsAxiosClient(options).patch(
    `${get(environmentVariables, 'SNS_SKIP_ITEM_INFO')}${get(user, 'UUID')}/skipItem`,
    payload,
  );
}

export default skipItem;
